export default {"src":"/_next/static/media/sprite.550d0017.svg","height":213,"width":214,"blurWidth":0,"blurHeight":0};